import { Fragment, FC } from "react";

const Taxonomy: FC<{ color: string }> = ({ color = "white" }) => {
  return (
    <Fragment>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 28C5.45 28 4.97917 27.8042 4.5875 27.4125C4.19583 27.0209 4 26.55 4 26V6.00004C4 5.45004 4.19583 4.97921 4.5875 4.58754C4.97917 4.19587 5.45 4.00004 6 4.00004H12.8333C12.9444 3.22226 13.3 2.58337 13.9 2.08337C14.5 1.58337 15.2 1.33337 16 1.33337C16.8 1.33337 17.5 1.58337 18.1 2.08337C18.7 2.58337 19.0556 3.22226 19.1667 4.00004H26C26.55 4.00004 27.0208 4.19587 27.4125 4.58754C27.8042 4.97921 28 5.45004 28 6.00004V26C28 26.55 27.8042 27.0209 27.4125 27.4125C27.0208 27.8042 26.55 28 26 28H6ZM6 26H26V6.00004H6V26ZM9.33333 22.6667H18.4333V20.6667H9.33333V22.6667ZM9.33333 17H22.6667V15H9.33333V17ZM9.33333 11.3334H22.6667V9.33337H9.33333V11.3334ZM16 5.43337C16.3111 5.43337 16.5833 5.31671 16.8167 5.08337C17.05 4.85004 17.1667 4.57782 17.1667 4.26671C17.1667 3.9556 17.05 3.68337 16.8167 3.45004C16.5833 3.21671 16.3111 3.10004 16 3.10004C15.6889 3.10004 15.4167 3.21671 15.1833 3.45004C14.95 3.68337 14.8333 3.9556 14.8333 4.26671C14.8333 4.57782 14.95 4.85004 15.1833 5.08337C15.4167 5.31671 15.6889 5.43337 16 5.43337Z"
          fill={color}
        />
      </svg>
    </Fragment>
  );
};

export default Taxonomy;
